package com.milta.feature.ocrscan.data.repository

import com.milta.feature.ocrscan.data.remote.OcrScanApi
import com.milta.feature.ocrscan.data.remote.dto.toDomain
import com.milta.feature.ocrscan.domain.entity.OcrScanResult
import com.milta.feature.ocrscan.domain.repository.OcrScanRepository

class OcrScanRepositoryImpl(private val api: OcrScanApi) : OcrScanRepository {
    override suspend fun scanPhoto(fileBytes: ByteArray, fileName: String): OcrScanResult =
        api.scanPhoto(fileBytes, fileName).toDomain()
}
